<div  [ngClass]="{'container':true,'en': (currentLanguage | async) === 'en','he': (currentLanguage | async) === 'he'}">
  <div class="locus-basket-list-container">
    <div class="title">
      {{'iaa.app.locus.locusBasket.locusBasketItem.basketDetails' | translate}}
    </div>
    <div class="basket-list-container">
      <p-listbox [(ngModel)]="selectedBasketId" [options]="locusBasketList" optionLabel="item" (onChange)="setSelected($event.value)">
        <ng-template let-basket pTemplate="item">
          <div [ngClass]="{'is-selected': basket.isSelected, 'p-highlight': basket.isSelected }"
            class="flex align-items-start gap-0 p-0 border-round"
            style="direction: rtl; font: normal normal bold 0.875rem Assistant"
            >
            <div>
              {{basket?.basketNo}}
            </div>
          </div>
        </ng-template>
      </p-listbox>
    </div>
  </div>
  <locus-basket-item *ngIf="!!selectedBasket" [basketItem]="selectedBasket!" />
</div>